import React, { useState, useEffect, useRef } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  TextField,
} from "@mui/material";

export default function WhatsAppCodeModal({ open, onClose, onConfirm, onResendCode, erroCodigo,setErroCodigo }:any) {
  const [code, setCode] = useState(["", "", "", ""]);
  const [timer, setTimer] = useState(60);
  const [error, setError] = useState(false);
  const inputsRef = useRef<any>([]);

  useEffect(() => {
    if (!open) return;

    setCode(["", "", "", ""]);
    setTimer(60);
    setError(false);
    
    const interval = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          onClose();
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [open]);

  const handleChange = (index:any, value:any) => {
    if (!/^\d?$/.test(value)) return;
    const newCode = [...code];
    newCode[index] = value;
    setCode(newCode);

    if (value && inputsRef.current[index + 1]) {
      inputsRef.current[index + 1].focus();
    }
  };

  const handleConfirm = async () => {
    const finalCode = code.join("");
    try {
      await onConfirm(finalCode);
      setError(false);
    } catch {
      setError(true);
      setCode(["", "", "", ""]);
      inputsRef.current[0]?.focus();
    }
  };

  const handleKeyDown = (e: any, index: any) => {
    if (e.key === "Backspace" && !code[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  
    if (e.key === "Enter" && code.every((digit) => digit !== "")) {
      handleConfirm();
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ margin: "0 auto" }}>Confirmação via WhatsApp</DialogTitle>
      <DialogContent >
        <Typography sx={{ textAlign: "center" }}> Insira o código enviado para seu WhatsApp:</Typography>
        <Box
          display="flex"
          gap={2}
          justifyContent="center"
          alignItems="center"
          flexWrap="nowrap"
          mt={2}
          sx={{ flexDirection: "row !important" }}
        >
          {code.map((digit, idx) => (
            <TextField
              key={idx}
              inputRef={(el) => (inputsRef.current[idx] = el)}
              autoFocus={idx === 0}
              inputProps={{
                maxLength: 1,
                style: {
                  textAlign: "center",
                  fontSize: "1.5rem",
                  width: "3rem",
                  height: "3.5rem",
                },
              }}
              sx={{
                '& .MuiInputBase-input': {
                  padding: '0px !important'
                },
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: '#6c5af4',
                  },
                  '&:hover fieldset': {
                    borderColor: '#6c5af4',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#6c5af4',
                  },
                },
                '& input': {
                  color: '#6c5af4',
                },
              }}
              type="text"
              value={digit}
              onChange={(e) => handleChange(idx, e.target.value)}
              onKeyDown={(e) => handleKeyDown(e, idx)}
              error={error}
            />
          ))}
        </Box>

        {erroCodigo && (
          <Typography color="error" mt={2}>
            Código verificador errado. Um novo código foi enviado
          </Typography>
        )}

        <Typography mt={2} align="center">
          {timer > 30 ? (
            `Reenviar código em ${timer}s`
          ) : (
            <Button
              onClick={onResendCode}
              sx={{
                color: "#6c5af4",
                fontWeight: "bold",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#f3f0ff",
                },
              }}
            >
              Reenviar código
            </Button>
          )}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ margin: "0 auto" }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            color: "#6c5af4",
            borderColor: "#6c5af4",
            "&:hover": {
              backgroundColor: "#f3f0ff",
              borderColor: "#6c5af4",
            },
          }}
        >
          Cancelar
        </Button>
        <Button
          onClick={handleConfirm}
          disabled={code.some((digit) => digit === "")}
          variant="contained"
          sx={{
            backgroundColor: "#6c5af4",
            color: "#fff",
            fontWeight: "bold",
            "&:hover": {
              backgroundColor: "#5949d6",
            },
            "&:disabled": {
              backgroundColor: "#d3d3d3",
              color: "#888",
            },
          }}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
